import { ruyi } from '@/components/xbot/ruyi.js'
import { post } from '../util/axios'
import { pinyin } from 'pinyin-pro'
/**
 * T9聊天机器人类
 */
export class xbot {
    user//虚拟人对象
    auto = true;//是否自动回答
    options = { //机器人的基本信息
        botype: "ruyi",//默认聊天机器人
        botkey: "",//聊天机器人ID
        botname: "",//聊天机器人名字
    }
    //包含以下疑问词，会定性为疑问句
    // keyword = ["?", "？", "吗", "什么", "哪儿", "多少",
    //     "会不会", "是不是", "能不能", "可不可以", "算不算", "有没有",
    //     "难到", "怎么", "莫非", "多大", "多高", "多长"
    // ];
    // 暂时关闭疑问句回复，仅保留预设问题全字匹配
    keyword = ["???"];
    QAlist = [];//预设QA问题
    constructor(options, qaList) {
        if (options) {
            // this.options = options;
            Object.assign(this.dboption, options)//更新配置
        }
        if (qaList) {//常见问题
            this.QAlist = qaList
        }
    }
    /**
     * 分析直播间弹幕，选择性回答
     * @param {*} question 
     */
    liveanswer (question, user) {
        return new Promise((resolve, reject) => {
            var qaobj = this.analysis(question)
            if (JSON.stringify(qaobj) == '{}') { //暂时忽略，不重要的内容
                resolve(qaobj)
                return
            }

            if (qaobj.type == "2") { //需要机器人回答的问题
                if (this.auto) { //自动回答
                    var chatbot = new ruyi(user.rolesName)
                    chatbot.send(question, user.userId).then((data) => {
                        qaobj.a = data.text
                        resolve(qaobj)
                    })
                }
                else { //手动回答
                    resolve(qaobj)
                }
            }
            else {
                //直播间回答
                resolve(qaobj)
            }
        })
    }
    /**
     * 分析问题，返回问答对象
     * @param {*} question 
     * @returns 
     */
    analysis (question) {
        // console.log("分析问题的问题：" + question, '预设问题的数组', this.QAlist)
        var qaobj = {}
        //先看看问答库里有没有
        for (var i = 0; i < this.QAlist.length; i++) {
            // if (question.indexOf(this.QAlist[i].question) >= 0) {
            if (question === this.QAlist[i].question) {
                // console.log('问答库中的问题')
                qaobj.type = "1"
                qaobj.a = this.QAlist[i].answer
                qaobj.q = question
                break
            }
        }
        //如果没有，再看看是不是疑问句
        if (JSON.stringify(qaobj) == '{}') {
            for (var i = 0; i < this.keyword.length; i++) {
                if (question.indexOf(this.keyword[i]) >= 0) {
                    console.log('如果没有,走疑问句')
                    qaobj.type = "2"
                    qaobj.q = question
                    qaobj.a = ''
                    break
                }
            }
        }
        return qaobj
    }
    /**
     * 向机器人提问
     */
    questions (msg, user, t9render) {
        return new Promise((resolve, reject) => {
            if (this.options.botype == "ruyi") {
                if (this.auto) { //自动回答
                    var chatbot = new ruyi(user.rolesName)
                    chatbot.send(msg, user.userId).then((data) => {
                        //业务变更，不再直接回答
                        // this.answer(data,user,t9render,function(){
                        //     resolve(data);
                        // });
                        var qa = {}
                        qa.q = msg
                        qa.a = data.text
                        qa.emotion = data.emotion
                        qa.type == "1"
                        resolve(qa)
                    })
                }
                else {
                    var qa = {}
                    qa.q = msg
                    qa.a = ""
                    qa.type == "1"
                    resolve(qa)
                }
            }
            else {
                resolve("")
                console.log("暂无其他聊天机器人")
            }
        })
    }

    /**
     * 将QA转为TTS
     * @param {*} msg 
     * @param {*} user 
     */
    qa2tts (qa, user) {
        let arr = ["刚才有粉丝朋友问我:", "有粉丝问:"]
        let index = Math.floor((Math.random() * arr.length))
        return new Promise((resolve, reject) => {
            let qaaswer = arr[index] + "“" + qa.q + "”。" + qa.a
            this.hecheng({
                text: qaaswer,
            }, user).then((data) => {
                var ttscontant = {
                    id: qa.id,
                    text: qaaswer,
                    tts: data.url,
                    kx: this.pinyin2mouth(qaaswer)
                }
                resolve(ttscontant)
            })
        })
    }

    /**
     * 回答问题
     * @param {*} msg 
     */
    answer (msg, user, t9render, callback) {

        // console.log(msg);
        this.hecheng(msg, user).then((data) => {
            callback(data)
            var ttscontant = {
                text: msg.text,
                tts: data.url,
                kx: this.pinyin2mouth(msg.text)
            }
            if (msg.emotion) {
                var arr = msg.emotion.split(" ")
                //遍历字符数组
                for (var i = 0; i < arr.length; i++) {
                    //把第一个字符变为大写,其余字符变为小写
                    arr[i] = arr[i].slice(0, 1).toUpperCase() + arr[i].slice(1).toLowerCase()
                }
                ttscontant.emotion = arr.join(" ")
            }
            ttscontant.user = user
            t9render.runfunction("speak", [user, ttscontant])//正常应该传资源对象，现在传当前角色
        })
    }

    /**
     * 将回答内容合成成语音
     */
    hecheng (msg, user) { //合成语音，返回URL
        return new Promise((resolve, reject) => {
            let tts = ""
            if (user.tts) {
                tts = JSON.parse(user.tts)
            }
            console.log('合成语音时接收的tts对象是否有id,user:', user)
            let param = { //拼接合成语音的参数
                text: msg.text,
                language: tts.language ? tts.language : "普通话",
                rid: tts.id ? tts.id : "zh-CN-XiaoxiaoNeural",
                rate: 1,
                volume: 100
            }
            if (msg.emotion) { //情感
                param.style = msg.emotion
            }

            post("/audiotts/tts", param).then((res) => {
                if (res.status == 200) {
                    resolve(res.data)
                }
            })
        })
    }

    /**
    * 通过对文本分析，获得口型集合
    */
    pinyin2mouth (text) {
        var mouth = []
        //将文本中的韵母拆出
        var yunmu = pinyin(text, { pattern: 'final', toneType: 'none', type: 'array' })
        // var shengmu = pinyin(text,{ pattern: 'initial', toneType: 'none', type: 'array' }); 
        // console.log("哈哈",yunmu);
        //根据韵母发音不同，对照进入5个原因口型
        var pipeibiao = {
            A: ["a", "an", "ia", 'ang', "2", "8"],//啊的因，大开
            E: ["i", "e", "ei", "ie", "en", "er", "eng", "1", "7"],//依的因，闭合拉宽
            I: ["ai", 'in', "ing", "3", "4", "0"],//和E差不多
            O: [],
            U: ["o", "ao", 'ui', "iao", "ong", "u", "ü", "üe", "ou", 'un', "uan", "ün", "5", "6", "9"]//优的因，嘟嘴
        }
        // var shengmubiao ={
        //     E:["z","c","s","y"],
        //     U:["w","r","zh","ch","sh"]
        // }
        for (var i = 0; i < yunmu.length; i++) {
            //插入声母口型
            // var zhaodao1 = false;
            // for(var key in shengmubiao){
            //     if(shengmubiao[key].indexOf(shengmu[i]) >=0)
            //     {
            //         mouth.push(key); //未识别口型
            //         zhaodao1 = true;
            //         break;
            //     }
            // }
            // if(!zhaodao1) //未识别口型，和闭口音
            // {
            //     mouth.push("O"); //未识别口型
            // }

            //插入韵母口型
            var zhaodao = false
            for (var key in pipeibiao) {
                if (pipeibiao[key].indexOf(yunmu[i]) >= 0) {
                    mouth.push(key) //未识别口型
                    zhaodao = true
                    break
                }
            }
            if (!zhaodao) //未识别口型，和闭口音
            {
                mouth.push("O") //未识别口型
            }
        }
        return mouth
        // console.log(yunmu,this.mouth);
    }

}